import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>개인 정보 보호 정책을</h2>
                <p><strong>Dreamehome개인 정보 보호정책</strong></p>
                <p><strong>시작하며</strong></p>
                <p>‘Dreamehome’은 Dreame Innovation Technology (Suzhou) Co., Ltd. 및 관련 기업 (이하 ‘저희’ 혹은 ‘드리미’라고 칭함) 이 운영하고, 고객님께 스마트
                    하드웨어
                    설비 조종 및 관리 서비스를 제공하는 플랫폼(서비스)이다. 저희는 귀하 개인 정보 보호의 중요성을 충분히 인지하고 귀하의 개인 정보 보호를 위해 최선을 다할 것을 약속 드립니다. 귀하의 개인 정보
                    보호를
                    위해서 저희는 업계에서 인증하는 안전 규범에 따라 관련 안전 보호 조치를 취합니다.. </p>
                <p>따라서 당사의 어플 (서비스)를 이용하시기 전에 이 《Dreamehome개인 정보 보호정책》을 자세히 읽어주시기 바랍니다.</p>
                <p>미성년자인 경우에는 보호자의 동의하에 본 앱을 사용하며 관련된 앱 서비스 이용약관에 동의하여 주시기바랍니다.</p>
                <p>본 개인 정보 보호정책을 제정 시 귀하의 요구를 충분히 고려하며 당사가 어떠한 개인정보를 수집하고, 그것을 어떻게 이용할지를 전면적으로 알려드립니다. 그 동시에 당사에 제공된 개인정보를 귀하가 관리할수
                    있는것이 제일 중요합니다. 본 개인 정보 보호정책은 귀하가 당사의 애플리케이션 사용하실때 제공하는 정보를 어떻게 수집,사용,공개,처리 및 액세스하는 방법을 규정합니다. 당사가 이 개인 정보 보호정책에
                    따라
                    엄격히 규칙을 지키고 정보를 이용합니다. </p>
                <p>본 개인 정보 보호정책은 이하의 내용 포함됩니다:</p>
                <p>1. 당사가 어떠한 정보를 수집하는지, 어떻게 이용하는지</p>
                <p>2. 당사가 어떻게 Cookie나 유사 기술을 사용하는지</p>
                <p>3. 당사가 어떻게 귀하의 개인정보를 위탁 처리, 공유, 이전 및 공개하는지</p>
                <p>4. 당사가 어떻게 귀하의 개인 정보를 액세스하고 보호하는지</p>
                <p>5. 귀하의 권리</p>
                <p>6. 국가 간 데이터 전송</p>
                <p>7. 당사의 연락처</p>
                <p>8. 본 개인 정보 보호 정책 변경사항</p>
                <p>관련 시트: 제3자 SDK 자료</p>
                <p>마지막으로 귀하에게 최적화된 경험를 제공해주는 것이 당사의 목표입니다. 당사는 프라이버시 및 개인정보 문제를 처리하는 전문 부서와 인원을 운영합니다. 본 개인 정보 보호정책에 대한 질문이 있으신 분들은
                    이
                    정책의 제7항에 있는 연락처로 언제나 연락하여 주시기 바랍니다. 귀하가 거주한 국가 또는 지역에 따라서 적용되는 법령 및 규제에 의해 지정된 시간 안에 답변을 드리겠습니다. 답변에 대해 불만이
                    있으시거나 특히
                    당사가 개인정보를 처리하는 방법이 귀하의 합법적인 권익이 손상되었다고 판단하시면 관할권을 가진 법원에 소송을 제기하거나 정부 규제기관에 신고하는 등 외부 경로를 통해 해결할수도 있습니다.</p>
                <h2>1、당사가 어떠한 정보를 수집한지, 어떻게 이용하는지</h2>
                <p>개인 정보란 전자적인 또한 다른 방식으로 기록될수 있는, 정보 자체를 통하거나 다른 정보를 연관시킨 후 특정 개인을 알아볼수 있는 다양한 데이터를 말합니다.</p>
                <p>개인 민감정보란 한 번 유출되거나 불법으로 제공되거나 남용되면 신변과 재산안전을 해칠 수 있고 개인의 명예, 심신건강으로부터 피해나 차별적 처우 등을 받을 수 있는 개인정보를 말한다.
                    주민등록번호,개인생체인식정보,은행계좌번호,재산정보,행방정보,거래정보,14세 이하(포함)아동의 개인정보 등에 포함됩니다.</p>
                <p>개인정보 수집의 주요 목적은 제품 및 서비스를 제공하고, 적용 가능한 관련 법률, 규정 및 기타 규범적 문서를 준수하도록 보장하는 것이다. 이 정보를 제공할지 여부를 선택할 권리가 있지만, 대부분의
                    경우,
                    제공하지 않으면 해당 서비스를 제공할 수 없으며, 문제 발생시 대응할 수 없습니다.</p>
                <h3>（A）Dreamehome기본서비스가 귀하의 개인 정보를 수집하고 처리하는 경우</h3>
                <h4>（a） Dreamehome애플리케이션과 지능형 하드웨어와의 연결 및 관리</h4>
                <p>Dreamehome 서비스를 제공하기 위해서 지능형 하드웨어 기기와 안전하게 연결 및 관리할수 있도록 귀하의 Wi-Fi 정보, 위치 정보, 계정 정보, 스마트폰 관련된 정보,지능 하드웨어 기기 관련
                    정보,
                    그리고 주이미 계정과 지능형 하드웨어 기기의 관련 정보 등 수집합니다. 위 정보들은 지능형 하드웨어 기기와의 빠른 연결, 연결, 주변 기기 찾기, 기기 관리 등의 기능을 사용할 수 있도록 이용 됩니다.
                    위
                    수집정보의 자세한 내용은 다음과 같습니다:</p>
                <p>계정 정보: 귀하의 주이미 계정 아이디, 비밀번호, 계정 이름, 프로필 사진, 이메일, 전화번호. <strong>이 중 계정 이름, 비밀번호, 전화번호, 이메일은 개인 민감정보이며</strong>, 이런
                    정보들를 수집하는 목적은 주이미 계정 로그인 시 서버에 사용자 ID를 인증하고, Dreamehome 계정으로 서버에 액세스할 수 있는 권한을 얻기 위한 것이다.입력한 계정 이름 및 로그인 비밀번호 인증
                    정보는
                    로그인 인증을 위해서 주이미 계정 서버로 암호화 되어 전송됩니다 .</p>
                <p>휴대폰 관련 정보: 하드웨어 기기 식별번호(IMEI/OAID, Mac 주소, Android ID), 휴대폰 모델, 시스템 버전 정보, 시스템 언어, 휴대폰 설정된 국가 또는 지역, 휴대폰 화면 크기 및
                    해상도, CPU 및 디스플레이 장치 관련 정보.이러한 정보들을 수집하는 목적은 Dreamehome 애플리케이션이 지능형 하드웨어 기기를 연결할 수 있도록 하기 위해서 입니다.</p>
                <p>지능형 하드웨어 기기에 대한 정보: 지능형 하드웨어 기기의 이름, 모델, 버전, 프로덕션 업체, 기기 식별번호, MAC 주소, IP 주소, 기기 작동 상태, 속성 정의, 파라미터 설정, 비즈니스 이벤트
                    및
                    기기 제어 및 사용 기록.이러한 정보를 수집하는 목적은 지능 하드웨어 기기를 연동하고, 기기를 제어 및 관리하며, 기기 속성과 파라미터를 설정하고, 기기의 작동 상태 및 기록을 확인하기 위한 것입니다.
                </p>
                <h4>（b） Dreamehome애플리케이션와 지능 하드웨어의 업데이트</h4>
                <p>귀하가 지속적으로 최신의 Dreamehome 서비스를 이용할 수 있으며 애플리케이션의 업그레이드 서비스를 제공할 수 있도록 Dreamehome 앱의 버전 정보, 휴대폰 모델 정보를 이용할 수도
                    있습니다.또한
                    최신 버전의 서비스(펌웨어 버전을 포함 )를 사용할 수 있도록 연결된 지능형 하드웨어 기기 목록과 버전 번호 정보를 수집하며 지능형 하드웨어 기기의 업그레이드 기능을 제공합니다. Dreamehome는
                    지능형
                    하드웨어 기기의 업그레이드 경로만을 제공하며, 지능형 하드웨어 기기 펌웨어 버전은 지능형 하드웨어 기기의 생산 업체가 제공하고, 버전 품질 및 업그레이드 결과에 대해서는 생산 업체가 책임을 집니다.
                </p>
                <p>이러한 정보를 제공하지 않으면 Dreamehome 애플리케이션 및 지능형 하드웨어 기기 펌웨어의 새 버전을 업그레이드할 수 없습니다.</p>
                <h4>（c）온라인 문제 피드백 </h4>
                <p>Dreamehome 애플리케이션, 지능형 하드웨어 기기에서 발생할 수 있는 문제를 더욱 효과적으로 해결할 수 있도록 온라인으로 피드백할 수 있는 채널을 제공합니다. 이러한 기능을 구현하기 위해서는 이하의
                    정보를 수집해야 합니다: Dreamehome 애플리케이션 및 기기의 로그 정보, 피드백에 있는 귀하의 연락처 및 문제 설명, 문제 현상 그림, 동영상 등. 애플리케이션 및 기기의 로그 정보에는 기기
                    상태,
                    센서에 기기가 인식된 정보, 기기 작동 기록, 기기 식별번호 등 포함되며, 이러한 정보를 수집하는 목적은 문제 원인 분석 및 위치을 찾기 위한 것이며, 귀하의 연락처를 수집하는 목적은 문제의 재발생을
                    추적하여
                    문제가 완전히 해결되었는지 파악하거나, 귀하에게 연락하여 필요한 기타 정보를 보충하기 위한 것입니다.</p>
                <p>당사는 이하의 방식으로 귀하의 개인 정보를 사용합니다: 피드백 문제에 대한 원인 분석 및 해결에만 사용되며, 개인 정보 전시, 상업 광고에 사용되지 않습니다. 귀하가 이러한 정보를 제공하지 않으면 피드백
                    받은 문제에 대한 효과적인 원인 분석 및 해결이 불가능합니다.</p>
                <h3>（B） Dreamehome기본 서비스 이외의 개인 정보를 수집하여 처리하는 경우</h3>
                <p>Dreamehome는 기본 서비스에서 귀하의 개인 정보를 이용할 뿐만 아니라, 당사의 다음 추가 기능에서도 개인 정보를 수집하여 사용할 수 있습니다.이러한 개인 정보를 제공하지 않을 경우,
                    Dreamehome 의 기본 서비스를 계속 사용할 수 있지만, 편리성를 느낄 수 있는 추가 기능을 사용할 수 없을 수도 있습니다. 추가 기능은 다음과 같습니다:</p>
                <p><strong>사용자 경험 개선 프로그램:</strong></p>
                <p>사용자 경험을 개선시키기 위해 이하의 정보를 수집합니다: 암호화된 주요 프로세스 로그, 이벤트 로그, 장애 로그, 비즈니스 이벤트, Dreamehome 각 인터페이스의 이용 형태 등이 포함된
                    Dreamehome의 로그를 수집해야 하며, 중요한 정보는 로그에 기록되지 않습니다.</p>
                <p>상기 정보를 자동으로 수집하여 서버에 업로드한 다음에 로그 정보를 분석하고 기기 작동 상태를 진단하며 앱 이용 형태을 분석하는 방식으로 귀하의 개인정보를 사용합니다.</p>
                <p>이러한 정보를 제공하지 않으면 Dreamehome가 사용자 경험을 신속하게 개선할 수 없습니다. 그러나 이것은 본 서비스의 기본 기능을 사용하는데 영향을 미치지 않습니다.</p>
                <h3>（C）제3자로부터 귀하의 개인 정보를 제공받은 경우</h3>
                <p>일부 법적으로 허용되는 경우에는, 우리는 제3자로부터 당신의 개인 정보를 얻을 수 있습니다. 예)</p>
                <p>1. 당신이 권한을 부여하는 범위 내에서, 제3자의 지능형 하드웨어 기기 관리 업무에서, 우리는 제3자의 서비스 제공 업체와 협력할 것입니다. 그중에서 우리는 제3자의 서비스 제공 업체로부터 귀하의 개인
                    정보를 얻습니다.제3자 설비 관리 업무에서, 우리는 귀하의 제3자 계정을 연동하는 조건 하에서 아래의 개인 정보를 얻을 수 있습니다.</p>
                <p>Dreamehome 애플리케이션에 이용할수 있도록 귀하의 계정 이름, 프로필 사진를 포함한 제3자 계정의 정보를 수집합니다.</p>
                <p>현재 작동하는 기기를 식별하고 기기 보안 제어를 수행하기 위해서 기기 식별번호, MAC 주소, 기기 시퀀스 번호가 포함된 기기 및 네트워크 정보를 수집합니다. </p>
                <p>당사가 업무 수행 시 필요한 개인정보를 처리 행위은 귀하가 제3자 서비스 제공업체에게 개인정보를 제공해도 된다는 권한을 부여한 범위를 벗어나는 경우엔, 귀하의 명시적 동의를 얻은 후 귀하의 개인 정보를
                    처리하겠습니다.또한 관련 법률 및 규정을 엄격히 준수하고 제3자 서비스 제공업체에게 제공하는 정보의 합법성을 보장하도록 요청할 것입니다.</p>
                <h3>（D）비개인 정보</h3>
                <p>또한 특정 개인에 대해 인식할 수 없는 다른 정보(즉, 개인 정보에 속하지 않는 정보)를 수집할 수도 있습니다.예를 들면, 귀하가 특정 서비스를 이용에 관한 통계 데이터, 조작 기록(클릭, 페이지 점프,
                    찾아보기 시간 등 포함됨). 이러한 정보를 수집하는것은 귀하에게 제공하는 서비스를 개선하려는 목적이 있습니다.수집되는 정보의 범주와 양은 당사의 제품 및 서비스를 사용하는 방법에 따라 달라집니다.
                    고객에게
                    더욱 도움될 정보를 제공하기 위하여 당사가 이러한 정보를 요약하며 고객은 웹 사이트, 제품 및 서비스 중 어떤 부분에 가장 관심을 갖고 있는지 파악하고 서비스 화면를 최적화할 수 있도록 합니다.본 개인
                    정보
                    보호 정책에 요약된 통계 데이터는 비개인 정보로 여깁니다.비개인 정보를 개인 정보와 함께 사용할 경우에 함께 사용하는 동안 해당 정보는 개인 정보로 간주됩니다.</p>
                <h2>2、당사가 어떻게 Cookie나 유사 기술 사용하는지</h2>
                <p>Dreamehome가 제대로 작동할 수 있도록 쿠키라는 작은 텍스트 파일을 기기에 저장됩니다.쿠키에는 일반적으로 식별번호, 사이트 이름 및 일부 번호와 문자가 포함됩니다.쿠키를 사용하여
                    Dreamehome는
                    웹 사이트 로그인 계정, 기본 설정 등의 데이터를 저장할 수 있습니다.</p>
                <p>이 선언문에서 설명한 목적 이외의 용도로 쿠키를 사용하지 않습니다.사용자의 선호도에 따라 쿠키를 관리하거나 삭제할 수 있으나, 그럴 경우 Dreamehome 보안 액세스에 영향을 줄 수 있으며
                    Dreamehome를 액세스할 때마다 사용자가 설정을 직접 변경해야 합니다.</p>
                <h2>3、당사가 어떻게 개인 정보를 위탁 처리, 공유, 이전 및 공개하는지?</h2>
                <h3>（A）위탁 처리</h3>
                <p>일반적으로 주이미는 귀하의 개인 정보를 처리할수 있게 다른 회사에게 업무를 위탁하는 경우가 있습니다.예를 들면 당사를 대신해 귀하에게 연락하거나 이메일을 보내거나 기술 지원을 제공하는 회사입나다. 이런
                    회사들은 당사 대신 귀하에게 서비스를 제공할때만 귀하의 개인 정보를 이용할 수 있습니다.</p>
                <p> 본 개인 정보 보호 정책 및 관련된 비밀유지, 보안대책을 준수하며 개인 정보를 처리할 수 있도록 당사는 업무 위탁처와 엄격한 비밀유지의무나 개인정보호 사항을 규정하는 계약을 체결할 것입니다.</p>
                <h3>（B）공유</h3>
                <p>일반적으로 귀하의 개인 정보를 외부에 공유하지 않습니다만, 다음과 같은 경우는 제외합니다:</p>
                <p>1. 귀하의 명시적 동의를 얻은 다음에 귀하가 지정한 제3자에게 귀하가 권한을 부여한 범위 안에 있는 정보를 공유하는 경우가 있습니다.또한 귀하의 요청에 따라 귀하의 스마트 홈 제품에 대한 정보와 구성
                    등
                    내용을 귀하의 가족이나 지인에게 공유하여 귀하의 친지들이 단말를 통해 본 소프트웨어와 서비스를 신속하게 사용할 수 있도록 합니다.</p>
                <p>2. Dreamehome 서비스의 일부 서비스 콘텐츠는 제3자 서비스 제공업체 제공하므로 웹 사이트 호스팅, 데이터 분석, 결제 및 신용 카드 처리, 인프라 공급, IT 서비스, 고객 지원 서비스,
                    이메일
                    발송 서비스 및 기타 유사한 서비스와 같은 개인 정보의 일부를 제3자 서비스 제공업체에게 제공하여 서비스를 제공할 수 있도록 해야 합니다.</p>
                <p>3. 지능형 하드웨어 기기 및/또는 웹 사이트와 서비스를 액세스하고 사용하는 네트워크 및 시스템을 직접 또는 간접적으로 제공하는 또는 제휴한 타사 및 기타 비즈니스 파트너에게 귀하의 개인정보를
                    공개합니다.
                </p>
                <p>4. 조직 개편, 합병, 매각, 합작 투자, 양도,업무의 전부 혹은 일부, 자산 또는 주식의 일부를 기타 처분(파산 또는 이와 유사한 절차와 관련된 경우를 포함)이 발생할 경우, 계열사 또는 기타
                    제3자에게
                    개인정보를 공개합니다.이런 경우에 이메일 및/또는 당사 웹사이트를 통해 소유권 변경, 개인정보의 새로운 이용 방법 및 개인 정보 선택에 관한 명확한 공지를 받게 됩니다.</p>
                <p>5. 필요하다고 판단되거나 적절하다고 판단되는 경우: (a) 적용되는 법체와 규제을 준수하고, (b) 법적 절차를 준수하며, (c) 귀하가 계신 국가 이외의 공공 기관 및 정부 당국을 포함하여 공공 기관
                    및
                    정부 당국의 요청에 응답하고, (d) 이용약관을 이행하며, (e) 우리의 운영, 업무 및 시스템을 보호합니다.(f) 귀하를 포함한 다른 사용자의 권리, 프라이버시, 보안 또는 재산 보호, (g) 사용
                    가능한
                    구제책을 구하거나 우리가 제공해야 할 손해 배상을 제한합니다.</p>
                <p>6. 자회사 또는 계열사에 귀하의 개인정보를 공개하여 정기적인 업무 활동을 할 수 있도록 합니다.</p>
                <p>7. API(Application Interface), 소프트웨어 개발 키트(SDK)를 통해 제3자와 필요한 데이터를 공유하며, 제3자 SDK 버전에 따라 일반적으로 제3자 계정 로그인 클래스, 공유
                    클래스, 제3자 결제 클래스, 공급업체 푸시 클래스, 통계 클래스 등 제3자에 대한 엄중한 보안 감지 및 데이터 보호 조치를 규정합니다.관련 파일1 당사가 권한을 부여한 제3자 SDK에 대한 자세한
                    내용입니다. 자세히 읽어보시기 바랍니다.당사의 개인 정보 보호 정책은 제3자가 제공하는 제품이나 서비스에 적용되지 않습니다.이러한 제품이나 서비스를 사용하실 때 귀하의 정보를 수집할 경우도
                    있습니다.따라서
                    당사의 정책을 읽는 것처럼 시간을 내어 해당 제3자의 개인 정보 보호 정책을 읽을 것을 강력히 권장합니다.당사는 제3자가 귀하에게 수집한 개인 정보를 어떻게 사용하는지에 대해 책임을 지지 않으며 그
                    사용을
                    통제할 수 없습니다.당사의 개인 정보 보호 정책은 당사 서비스를 통해 연결된 다른 웹 사이트에 적용되지 않습니다.링크된 웹 사이트와의 상호 작용을 본인 직접 판단해야 합니다. 제3자 서비스 제공업체는
                    처음
                    제3자 페이지로 이동하기 전에 관련 계약 및 개인 정보 보호 방침을 알려주므로 해당 계약 및 개인 정보 보호 정책을 자세히 읽어 보십시오.</p>
                <h3>（C）이전</h3>
                <p>주이미는 다음과 같은 경우를 제외하고 귀하의 개인 정보를 다른 회사나, 조직 및 개인에게 이전하지 않습니다.</p>
                <p>1.명시적 동의를 얻은 경우 이전: 귀하의 명시적 동의를 얻은 경우 귀하의 개인 정보를 이전합니다.</p>
                <p>2.합병, 인수 또는 파산 청산과 관련된 경우 개인 정보 이전과 관련하여 귀하의 개인 정보를 보유한 새로운 회사, 조직이 지속적으로 본 성명을 적용하도록 요청할 것이며, 그렇지 않으면 해당 회사, 조직이
                    귀하에게 재동의를 받도록 요청할 것입니다.</p>
                <h3>（D）공개</h3>
                <p>당사은 다음과 같은 경우에만 귀하의 개인 정보를 공개합니다.</p>
                <p>1. 명시적인 동의를 얻은 경우</p>
                <p>2. 법령 기반 공개: 법적 또는 법적 절차, 소송 또는 정부 담당 부서의 의무적인 요건에 부합하는 경우 개인 정보를 공개할 수 있습니다.</p>
                <h2>4、당사가 어떻게 귀하의 개인정보를 액세스하고 보호하는지</h2>
                <p>본 개인 정보 보호 정책에 설명된 정보 수집의 목적에 기초하여 필요한 기간 또는 관련 법률에 따라 개인 정보를 보유하도록 합니다.개인 정보는 수집 목적을 완료하거나 귀하의 삭제 또는 파기 신청을 확인한
                    후
                    또는 해당 제품이나 서비스의 운영을 종료한 후에 보유를 중지하고 삭제 또는 익명화로 처리합니다.공공의 이익, 과학, 역사 연구 또는 통계의 목적을 위한 것이라면, 추가 데이터 처리가 기존의 수집 목적과
                    무관하더라도 해당 법률에 근거하여 관련 데이터를 계속 보유할 것입니다.</p>
                <p>Dreamehome업무 중 귀하의 개인 데이터 보존기간은 다음과 같습니다:</p>
                <p>Dreamehome 어플리케이션 로컬에 저장된 데이터는, Dreamehome 어플리케이션을 삭제하거나 Dreamehome 어플리케이션 데이터를 지우 시 저장된 모든 데이터가 즉시 삭제됩니다.</p>
                <p>서버에 저장된 Dreamehome 지능 하드웨어 기기 및 비즈니스 데이터의 경우, 지능 하드웨어 기기를 삭제하거나, Dreamehome 개인 정보 보호 정책에 동의하기를 거부하며, Dreamehome
                    서비스
                    사용을 중지하면 저장된 모든 데이터가 즉시 삭제됩니다.</p>
                <p>서버에 저장된 비즈니스 로그, 통계 및 기록의 경우 서버 데이터를 비정기적으로 정리할 때 삭제되며, 데이터 보존 기간은 통상 2년 미만 입니다.</p>
                <p>또한 당사 제품이나 서비스는 운영 중단이 발생하는 경우 푸시 알림, 공지사항 등의 형태로 알려드리며, 합리적인 기간 내에 귀하의 개인정보를 삭제하거나 익명화 처리해드립니다.</p>
                <h2>5、귀하의 권리</h2>
                <h3>（A）귀하의 개인정보를 액세스,수정,삭제</h3>
                <p>해당 국가 또는 지역 법률에 따라 귀하와 관련된 개인 정보에 대한 액세스, 수정, 삭제할수 있는 권한을 가집니다(이하 요청이라 함).</p>
                <p>편지를 보내시거나 Dreamehome 방문을 통해 요청 바랍니다. 대부분의 법률에 따라서 개인 정보 주체의 요청이 특정 요구 사항을 따라야 하며, 본 개인정보 보호 정책에 요구하는 귀하의 요청은 다음과
                    같은
                    경우에 해당해야 합니다.</p>
                <p>저희 전문 요청 경로를 통해 귀하의 정보 보안을 지키기 위하여 귀하의 요청은 (지역법률에 명시적으로 구두 신청을 승인하는 경우 제외) 서면으로 하시기 바랍니다 </p>
                <p>귀하의 신분을 검증하고 요청자가 요청된 정보 주체 본인 또는 합법적인 권한자인지 확인할 수 있는 충분한 정보를 제공하시기 바랍니다.</p>
                <p>요청을 처리할 수 있는 충분한 정보를 얻으면 데이터 보호 법령에 적용되는 시간 내에 요청에 응답할겁나다. 구체적으로:</p>
                <p>당사은 귀하의 요구 사항 및 관련 법령에 따라 귀하가 개인 정보를 수집하여 처리한 기록을 무료로 제공할 수 있으며, 관련 정보에 대한 추가 요청을 요구하시면 관련 법령에 따라 실제 관리 비용과 함께
                    고려하여
                    합리적인 비용을 청구할 수 있습니다.</p>
                <p>귀하에 대해 보유하는 정보가 부정확하거나 불완전하다고 판단될 경우 사용 목적에 따라 개인 정보를 수정하거나 보완할 수 있습니다.</p>
                <p>해당 법률과 규정에 따라 귀하의 개인 데이터를 삭제하도록 요청할 수 있는 권한이 있습니다.귀하의 삭제 요청에 따라 평가될 것이며, 해당 규정이 적용될 경우 기술적인 수단을 포함한 적절한 절차를 거쳐
                    처리될
                    것입니다.관련 정보를 삭제하면 해당 법률 및 보안 기술로 인해 백업 시스템에서 해당 정보가 즉시 삭제되지 않을 수 있으며, 백업이 지워지거나 익명이 될 때까지 개인 정보를 안전하게 저장하고 추가
                    처리로부터
                    격리할 수 있습니다.예를 들어 《중화인민공화국 전자 상거래법》에 따라 귀하의 상품 및 서비스 정보, 거래 정기의 보존 기간은 거래 완료일로부터 3년 미만 입니다.</p>
                <p>당사는 의미없는 반복된 요청, 타인의 프라이버시 권리를 해치는 요청, 극단적으로 비현실적인 요청, 비합리적인 기술 업무 요청, 지역 법령에 의해 필요가 없는 요청, 이미 알려진 정보, 비밀유지 조건에
                    주어진
                    정보 처리를 거부할 권리가 있습니다.데이터 삭제 또는 데이터 액세스 요청의 일부 측면으로 앞서 언급한 부정 행위 방지 및 보안 목적으로 데이터를 합법적으로 사용할 수 없다고 판단되는 경우에도 거부할 수
                    있습니다.</p>
                <h3>（B）동의 파기</h3>
                <p>귀하는 저희가 보유하거나 가지고 있는 개인 정보의 수집, 사용 혹은 공개에 대해 동의 철회를 요청하실 수 있습니다. 사용 중이신 구체적인 서비스에 따라 개인 정보 보호 정책 제7조의 연락처로 연락해
                    주신다면
                    저희는 관련 조치를 취할 것입니다. 귀하가 요청하신 후 저희는 빠른 시일 내에 처리하고 요청 사항에 따라 개인 정보를 더 이상 수집, 사용 혹은 공개하지 않을 것입니다.</p>
                <p>귀하는 정보 처리 권한을 부여한 범위에 따라 Dreamehome 또는 지능형 하드웨어 제품에 서비스를 이용할 수 없게 될 수 있다는 것에 유의하십시오.그러나 귀하가 동의 또는 권한 부여 결정을 철회하는
                    것은
                    그동안 귀하의 권한에 기초하여 수행된 개인 정보 처리에 영향을 미치지 않습니다.</p>
                <p>액세스하여 동의 철회를 요청하거나 Dreamehome 페이지로 이동하여 변경을 수행하여 사용자경험 개선 프로그램을 종료하고 이 프로그램에 개인 정보 사용에 대한 동의를 철회할 수 있습니다.</p>
                <h3>（C）Dreamehome계정 파기</h3>
                <p>‘내 정보’-‘계정’-‘계정 탈퇴’ 화면에서 Dreamehome 계정 탈퇴를 처리할 수 있습니다. Dreamehome 계정을 탈퇴하고 나서 Dreamehome 및 관련 스마트 하드웨어 제품과 서비스를
                    사용하지 못할 것을 주의하시고 다음 절차를 진행하시기를 바랍니다. 귀하 및 타인의 법적 권리를 보호하기 위해서 Dreamehome 스마트 하드웨어 제품 및 서비스 사용 상황을 참고해서 탈퇴 요청 수락
                    여부를
                    결정할 것입니다.</p>
                <h2>6、국가 간 데이터 전송</h2>
                <p>당사는 전세계의 리소스와 서버를 통해 제품이나 서비스를 제공하고 있으므로, 귀하의 권한을 부여받은 후 귀하의 개인 정보가 제품이나 서비스를 사용하는 국가의 해외 관할 지역으로 이동되거나 해당 관할
                    구역으로부터 액세스를 받을 수 있다는 것을 의미합니다.사용자의 정보가 전송될 수 있는 국가가 데이터 보호 조치 및 기타 법률은 해당 국가처럼 포괄적이지 않을 수 있습니다.이러한 경우 귀하의 개인 정보가
                    계속
                    보호될 수 있도록 각 관할 구역의 적용 법률에 따라 적절하고 합법적인 조치를 취합니다.</p>
                <p>특히 EEA(European Area) 거주자인 경우 EEA 밖에서 개인 정보를 전송하는 경우: 유럽 집행위원회에서 확인된 개인 정보를 처리할 수 있는 충분한 보호 수준을 제공할수 있는 구역에서만 귀하의
                    개인정보를 취급합니다; 유럽 집행위원회의 표준 계약 조건과 같은 적용 가능한 전송 메커니즘에 따라 전송하는 등 개인 정보를 보호할 수 있는 적절한 보호 조치를 취할 수 있습니다.</p>
                <h2>7、당사의 연락처</h2>
                <p>본 개인 정보보호정책에 대해 의견이나 문제가 있거나 개인정보를 수집, 이용 또는 공개하는 데 문제가 있는 경우 아래 주소 또는 Dreamehome 를 방문하여 문의하고 "개인 정보 보호 정책"에 대해
                    언급하십시오.개인 정보 관련 권리 요청, 문제 상담 등에 대해 귀하의 문제를 해결할 수 있는 전문 팀이 있습니다.귀하의 질문 자체가 비교적 중대한 사항들을 다룬다면, 당사는 귀하에게 더 많은 정보를
                    요구할
                    수도 있습니다.받은 답변에 만족하지 않을 경우 해당 사법 관할 지역의 관련 규제기관에 불만사항을 신고 할 수 있습니다. 당사에게 문의하시면 귀하의 상황에 따라 적용될 수 있는 관련 불만 신고 경로에
                    대한
                    정보를 제공해 드립니다.</p>
                <p><strong>이메일 주소:</strong></p>
                <ul>
                    <li>중국 사무처: <a className="page"
                        href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                    <li>싱가포르 DPO 사무처: <a className="page"
                        href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                    <li>EU 사무처: <a className="page"
                        href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
                </ul>
                <p><strong>연락처: </strong>400-875-9511</p>
                <p><strong>홈페이지 주소</strong>: <a className="page"
                    href="https://www.dreametech.com">https://www.dreametech.com</a></p>
                <h2>8、본 개인정보 보호 정책 변경사항</h2>
                <p>주이미는 본 정책을 변경할 수 있는 권한을 보유합니다.본 정책 변경 시 팝업 방식 또는 기타 유의한 방법으로 변경된 정책을 알려드립니다. 귀하의 동의를 얻어야만 변경된 정책에 따라 귀하의 개인 정보를
                    수집,
                    사용 및 저장할 수 있습니다.</p>
                <p>본 정책은 변경일로부터 적용됩니다.</p>
                <p>2021년 8월28일 개정</p>
                <p><strong>관련 시트: 제3자 SDK 자료</strong></p>
                <p>*더욱 전문적이고 안전한 기초 및 부가 기능 서비스를 제공하기 위해 제3자SDK제품을 Dreamehome 내에 설치하는 경우가 있습니다.</p>
                <p>지금 Dreamehome에 있는 제3자 SDK 제품 자료는 다음과 같습니다.</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>SDK 서비스</p>
                        </td>
                        <td>
                            <p>기능</p>
                        </td>
                        <td>
                            <p>정보 수집</p>
                        </td>
                        <td>
                            <p>제3자 개인정보보호정책</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>유멍 통계분석 SDK</p>
                        </td>
                        <td>
                            <p>통계분석</p>
                        </td>
                        <td>
                            <p>기기 식별번호(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 카드 IMSI 정보)、위치</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>유멍 메시지 푸시 SDK</p>
                        </td>
                        <td>
                            <p>메시지 푸시</p>
                        </td>
                        <td>
                            <p>기기 식별번호(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 카드 IMSI 정보)、위치</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>유멍 소셜 공유 SDK</p>
                        </td>
                        <td>
                            <p>제3자 공유</p>
                        </td>
                        <td>
                            <p>기기 식별번호(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 카드 IMSI 정보)、위치</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>마이크 연결, 비디오 스트리밍</p>
                        </td>
                        <td>
                            <p>기기 정보, 네트워크 상태, 카메라, 마이크, 읽기 및 쓰기 스토리지 공간</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>화웨이 푸시 SDK</p>
                        </td>
                        <td>
                            <p>푸시</p>
                        </td>
                        <td>
                            <p>기기 식별자 정보</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>샤오미 푸시 SDK</p>
                        </td>
                        <td>
                            <p>푸시</p>
                        </td>
                        <td>
                            <p>기기 식별 정보, 기기 모델, 네트워크 유형, 기기 저장소, 기기 실행 프로세스 정보, 애플리케이션 버전, SDK 버전</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPP푸시SDK</p>
                        </td>
                        <td>
                            <p>푸시</p>
                        </td>
                        <td>
                            <p>기기 식별자 정보</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO푸시SDK</p>
                        </td>
                        <td>
                            <p>푸시</p>
                        </td>
                        <td>
                            <p>기기 식별자 정보</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>위쳇SDK</p>
                        </td>
                        <td>
                            <p>위쳇 제3자 로그인,위쳇 공유</p>
                        </td>
                        <td>
                            <p>기기 식별자 정보,네트워크 정보</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>공유</p>
                        </td>
                        <td>
                            <p>기기 식별자 정보,네트워크 정보</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>웨이보SDK</p>
                        </td>
                        <td>
                            <p>웨이보 제3자 로그인,웨이보 공유</p>
                        </td>
                        <td>
                            <p>기기 식별자 정보,네트워크 정보</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>AppleID SDK</p>
                        </td>
                        <td>
                            <p>Apple ID로 로그인</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
                <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy